import React, { Component } from 'react';
import Channel from './Channel';
import { OrderedMap, List } from 'immutable';
import css from './media-platform.css';
import PlatformIcon from '../PlatformIcon';
import MdAdd from 'react-icons/lib/md/add';

import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { teal500 } from '../../colors';

class MediaPlatform extends Component {
  constructor(props) {
    super(props);
    this.state = { channels: OrderedMap({}), hiddenChannels: List() };
  }

  handleUpdateForm = (key, attributes) => {
    this.setState({ channels: this.state.channels.merge({ [key]: attributes }) });
  };

  addAnotherChannel = () => {
    this.setState({ channels: this.state.channels.merge({ [this.state.channels.size]: {} }) });
  };

  removeChannel = (key) => {
    this.setState({ channels: this.state.channels.delete(key) });
  };

  handleSavePlatform = () => {
    this.props.savePlatform(this.state.channels.toList());
  };

  handleToggleChannel = (id) => {
    if (~this.state.hiddenChannels.indexOf(id)) {
      this.setState({ hiddenChannels: this.state.hiddenChannels.delete(id) });
    } else {
      this.setState({ hiddenChannels: this.state.hiddenChannels.push(id) });
    }
  };

  render() {
    return (
      <div className={css.root}>
        <h3
          className={css.platformTitle}
          style={{ backgroundColor: teal500 }}
        >
          {PlatformIcon(this.props.platform.get('slug'), {
            color: 'white',
            style: { verticalAlign: 'sub' },
          })}
          {this.props.platform.get('name')}
        </h3>
        <h4 className={css.channelTitle}>
          Channels
          <FlatButton
            label="Add"
            labelPosition="before"
            icon={<MdAdd />}
            onTouchTap={this.addAnotherChannel}
          />
        </h4>
        {this.state.channels.mapEntries(([key, value]) =>
          [
            key,
            <Channel
              key={key}
              id={key}
              updateForm={this.handleUpdateForm.bind(this, key)}
              className={this.props.fieldClass}
              channelStyles={this.props.channelStyles}
              fullWidth={this.props.fullWidth}
              toggleChannel={this.handleToggleChannel}
              hidden={~this.state.hiddenChannels.indexOf(key)}
            />,
          ]
        ).toList()}
        <div className={css.actions}>
          <RaisedButton
            onTouchTap={this.props.cancelPlatform}
            label="Cancel"
            style={{ marginRight: '10px' }}
          />
          {this.state.channels.size && this.state.hiddenChannels.size === this.state.channels.size ?
            <RaisedButton
              onTouchTap={this.handleSavePlatform}
              secondary={true}
              label={`Add ${this.props.platform.get('name')}`}
            />
            : ''
          }
        </div>
      </div>
    );
  };
}

export default MediaPlatform;



/** WEBPACK FOOTER **
 ** ./components/forms/MediaPlatform.js
 **/